<form (ngSubmit)="submit()" [formGroup]="groupForm" action="" class="form">
  <div class="form__left">
    <app-button [enabled]="groupForm.valid" text="Adicionar" type="submit"></app-button>
    <app-input [control]="groupForm.get('name')" label="Nome"></app-input>
    <app-input [control]="groupForm.get('description')" label="Descrição" type="textarea"></app-input>
  </div>
</form>
